import { injectGlobal } from 'styled-components';

/* eslint no-unused-expressions: 0 */
injectGlobal`
  html,
  body {
    height: 100%;
    width: 100%;
    font-family: sans-serif;
    -webkit-font-smoothing: antialiased;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: sans-serif;
  }

  .btn.cognite-blue {
    background: #4592b2;
    color: white;
  }

  a {
    color: #4181bd;
  }

  .table-odd {
    background: #f9f9f9;
  }

  .ant-table-thead > tr > th {
    background: #E9F7FF !important;
    border-top: 1px solid #C2E8FF !important;
    border-bottom: 1px solid #C2E8FF !important;
  }

  .ant-table-thead > tr > th {
    padding-left: 18px;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/global-styles.js